import React, { useState } from 'react';
import {
  IoChevronDownOutline,
  IoChevronUpOutline,
  IoAddOutline,
  IoCloudDownload,
  IoDocumentTextOutline,
  IoPeople
} from 'react-icons/io5';

import styles from './collapse.module.scss';
import '../../theme/global.scss';
import CButton from '../../components/button/button';
import {
  downloadAditionalDocument,
  downloadFollowupRaport,
  downloadRaport,
  deleteAdditionalDocument,
  deleteFollowUpReport,
  deleteCcrReport
} from '../../network/raports';
import { ICard, IRaport } from '../../utils/interfaces/interfaces';
import 'antd/dist/antd.css';
import { Skeleton, Tooltip } from 'antd';
import { FiEdit } from 'react-icons/fi';
import { mapRaportsTitle } from '../../utils/strings';
import { typesActionsRaports } from '../../types/actions-raports';
import { IoMdTrash } from 'react-icons/io';
import { useGetCurrentUserQuery } from '../../api';
import { getRole } from '../../localStorage';
import { types_users } from '../../types/users';

const CCollapse = (props: ICard) => {
  const [opened, setOpened] = useState(false);
  const { raport } = props;

  const handleSwitch = () => {
    setOpened(op => !op);
  };

  const { data: user } = useGetCurrentUserQuery();
  const role = getRole();

  if (!raport || raport!.id === 0) {
    return <Skeleton active />;
  } else
    return (
      <div className={styles.card} id={props.id.toString()}>
        {props.onChangePermissions &&
          role &&
          role === types_users.principal && (
            <Tooltip
              title={mapRaportsTitle(
                typesActionsRaports.REPORT_PERMISSIONS,
                user?.institution.private
              )}
            >
              <CButton
                className={styles.assignPermissions}
                label={<IoPeople />}
                onClick={props.onChangePermissions}
                type='button'
              />
            </Tooltip>
          )}

        {props.onEdit && (
          <Tooltip
            title={mapRaportsTitle(
              typesActionsRaports.EDIT_RAPORT,
              user?.institution.private
            )}
          >
            <CButton
              className={styles.editDocument}
              label={<FiEdit />}
              onClick={props.onEdit}
              type='button'
            />
          </Tooltip>
        )}

        {props.onAdditionalDocument && (
          <Tooltip
            title={mapRaportsTitle(
              typesActionsRaports.ADDITIONAL_DOCUMENT,
              user?.institution.private
            )}
          >
            <CButton
              className={styles.aditionalDocument}
              label={<IoDocumentTextOutline />}
              onClick={props.onAdditionalDocument}
              type='button'
            />
          </Tooltip>
        )}

        {props.onAdd && (
          <Tooltip
            title={mapRaportsTitle(
              typesActionsRaports.ADD_FOLLOWUP,
              user?.institution.private
            )}
          >
            <CButton
              className={styles.addFollowUp}
              label={<IoAddOutline />}
              onClick={props.onAdd}
              type='button'
            />
          </Tooltip>
        )}
        <div className={styles.text} onClick={handleSwitch}>
          <p className='body-dark bold'>{props.title}</p>
          <button className={styles.switch}>
            Documente încărcate{' '}
            {opened ? <IoChevronUpOutline /> : <IoChevronDownOutline />}
          </button>
        </div>
        {opened && (
          <div className={styles.details}>
            <p className='body-dark faded'>Documente încărcate inițial</p>
            <div className={styles.list}>
              <CButton
                label={
                  <p className={styles.download}>
                    Raport inițial <IoCloudDownload />
                  </p>
                }
                onClick={() => downloadRaport(raport!.id, raport!.name)}
                type='button'
              />
              <CButton
                label={<IoMdTrash />}
                type='button'
                className={styles.delete}
                onClick={async () => {
                  if (window.confirm('Confirmati stergerea acestui raport')) {
                    await deleteCcrReport(raport.id);
                    if (props.onDelete) {
                      props.onDelete();
                    }
                  }
                }}
              />
            </div>
            <p className='body-dark faded'>Rapoarte de followup</p>
            <div className={styles.list}>
              {raport!.followupCcrReports &&
                raport!.followupCcrReports.map((document: IRaport) => (
                  <>
                    <CButton
                      key={document.id}
                      label={
                        <p className={styles.download}>
                          {`${document.name}`} <IoCloudDownload />
                        </p>
                      }
                      onClick={() =>
                        downloadFollowupRaport(document.id, document.name)
                      }
                      type='button'
                    />
                    <CButton
                      label={<IoMdTrash />}
                      type='button'
                      className={styles.delete}
                      onClick={async () => {
                        if (
                          window.confirm(
                            'Confirmati stergerea acestui raport follow-up'
                          )
                        ) {
                          await deleteFollowUpReport(document.id);
                          if (props.onDelete) {
                            props.onDelete();
                          }
                        }
                      }}
                    />
                  </>
                ))}
              {raport!.followupCcrReports &&
                raport!.followupCcrReports.length === 0 && (
                  <p className='small-dark faded'>
                    Nu au fost adaugate rapoarte de followup.
                  </p>
                )}
            </div>
            <p className='body-dark faded'>Documente aditionale</p>
            <div className={styles.list}>
              {raport!.additionalDocuments &&
                raport!.additionalDocuments.map((document: IRaport) => (
                  <>
                    <CButton
                      key={document.id}
                      label={
                        <p className={styles.download}>
                          {`${document.name}`} <IoCloudDownload />
                        </p>
                      }
                      onClick={() =>
                        downloadAditionalDocument(document.id, document.name)
                      }
                      type='button'
                    />
                    <CButton
                      label={<IoMdTrash />}
                      type='button'
                      className={styles.delete}
                      onClick={async () => {
                        if (
                          window.confirm(
                            'Confirmati stergerea acestui document aditional'
                          )
                        ) {
                          await deleteAdditionalDocument(document.id);
                          if (props.onDelete) {
                            props.onDelete();
                          }
                        }
                      }}
                    />
                  </>
                ))}

              {raport!.additionalDocuments &&
                raport!.additionalDocuments.length === 0 && (
                  <p className='small-dark faded'>
                    Nu au fost adaugate documente aditionale.
                  </p>
                )}
            </div>
          </div>
        )}
      </div>
    );
};

export default CCollapse;
